export const STAGES = [
  "New Accepted Lead", "New Lead", "Contacted", "Fact Find Complete", "Ready to Quote", "Quoted",
  "Application Started", "Application Submitted", "Pending Underwriting",
  "Approved as Quoted", "Approved - Higher Premium", "Approved - Lower Face Amount",
  "Declined - Requote Needed", "Issued / Active", "Follow-Up Due",
  "Client Declined", "Closed Lost",
];
export const FOLLOWUP_TYPES = [
  "NSF / Failed Draft Recovery", "Pre-Draft Funding Check", "First Premium Funding Check",
  "Payment Issue Escalation", "3-Day Policy Receipt Check", "30-Day Draft Check",
  "90-Day Persistency Check", "6-Month Check-In", "Annual Review",
  "Lapse / Reinstatement", "Historical Follow-Up",
];
export const FOLLOWUP_STATES = ["open", "in_progress", "completed", "no_action_needed", "rescheduled"];
export const APP_STATUSES = ["Not Started", "Started", "Submitted", "Decisioned"];
export const CARRIER_DECISIONS = [
  "", "Pending", "Approved", "Approved - Higher Premium", "Approved - Lower Face Amount", "Declined",
];

export const LEAD_FIELDS = [
  { key: "client_name", label: "Client Name", type: "text", required: true },
  { key: "phone", label: "Phone", type: "text" },
  { key: "email", label: "Email", type: "text" },
  { key: "state", label: "State", type: "select", optionsKey: "states" },
  { key: "age", label: "Age", type: "number" },
  { key: "date_received", label: "Date Received", type: "date" },
  { key: "lead_source", label: "Lead Source / Vendor", type: "select", optionsKey: "sources" },
  { key: "agency_contract", label: "Agency / Contract", type: "text" },
  { key: "lead_cost", label: "Lead Cost", type: "number" },
  { key: "lead_payment_due_date", label: "Lead Payment Due Date", type: "date" },
  { key: "lead_cost_paid", label: "Lead Cost Paid", type: "switch" },
  { key: "assigned_agent", label: "Assigned Agent / Owner", type: "select", optionsKey: "agents" },
  { key: "bpo_caller", label: "BPO / Caller", type: "select", optionsKey: "callers" },
  { key: "product_goal", label: "Product Interest", type: "select", optionsKey: "products" },
  { key: "target_face_amount", label: "Target Face Amount", type: "number" },
  { key: "target_monthly_budget", label: "Target Monthly Budget", type: "number" },
  { key: "monthly_premium", label: "Monthly Premium (for calc)", type: "number" },
  { key: "health_intake_complete", label: "Health Intake Complete", type: "switch" },
  { key: "missing_information", label: "Missing Information", type: "textarea" },
  { key: "carrier_recommendation", label: "Carrier Tried / Recommended", type: "select", optionsKey: "carriers" },
  { key: "quote_carrier", label: "Quote Carrier", type: "select", optionsKey: "carriers" },
  { key: "quote_product", label: "Quote Product", type: "select", optionsKey: "products" },
  { key: "quoted_face_amount", label: "Quoted Face Amount", type: "number" },
  { key: "quoted_premium", label: "Quoted / Premium", type: "number" },
  { key: "application_status", label: "Application Progress", type: "select", options: APP_STATUSES },
  { key: "application_started_date", label: "Application Started Date", type: "date" },
  { key: "application_submitted_date", label: "Submitted Date", type: "date" },
  { key: "issued_date", label: "Issued Date", type: "date" },
  { key: "draft_date", label: "Draft Date", type: "date" },
  { key: "paid_date", label: "Paid Date", type: "date" },
  { key: "carrier_decision", label: "Carrier Decision", type: "select", options: CARRIER_DECISIONS },
  { key: "policy_number", label: "Policy Number", type: "text" },
  { key: "effective_date", label: "Effective Date", type: "date" },
  { key: "commission_percentage", label: "Commission %", type: "number" },
  { key: "expected_commission", label: "Expected Commission", type: "number" },
  { key: "commission_received", label: "Actual Commission Received", type: "number" },
  { key: "commission_received_date", label: "Commission Received Date", type: "date" },
  { key: "net_commission", label: "Net Commission After Lead Cost", type: "number" },
  { key: "stage", label: "Pipeline Stage", type: "select", options: STAGES, required: true },
  { key: "next_action", label: "Next Action", type: "text" },
  { key: "next_action_date", label: "Follow-Up Date", type: "date" },
  { key: "next_action_time", label: "Follow-Up Time", type: "text" },
  { key: "followup_stage", label: "Follow-Up Stage", type: "select", options: ["", ...FOLLOWUP_TYPES] },
  { key: "disposition_outcome", label: "Disposition / Outcome", type: "text" },
  { key: "notes", label: "Notes", type: "textarea" },
];

export const MODULES = {
  quotes: {
    title: "Quotes & Applications", collection: "quotes", idLabel: "Quote",
    columns: [
      { key: "display_id", label: "ID", type: "mono" },
      { key: "client_name", label: "Client" },
      { key: "carrier", label: "Carrier" },
      { key: "product", label: "Product" },
      { key: "face_amount", label: "Face", type: "currency", align: "right" },
      { key: "monthly_premium", label: "Premium", type: "currency", align: "right" },
      { key: "quote_date", label: "Quote Date", type: "date" },
      { key: "application_submitted_date", label: "Submitted", type: "date" },
      { key: "carrier_decision", label: "Decision", type: "badge" },
      { key: "policy_number", label: "Policy #", type: "mono" },
      { key: "assigned_agent", label: "Agent" },
    ],
    fields: [
      { key: "client_name", label: "Client", type: "text", required: true },
      { key: "carrier", label: "Carrier", type: "select", optionsKey: "carriers" },
      { key: "product", label: "Product", type: "select", optionsKey: "products" },
      { key: "face_amount", label: "Face Amount", type: "number" },
      { key: "monthly_premium", label: "Monthly Premium", type: "number" },
      { key: "quote_date", label: "Quote Date", type: "date" },
      { key: "application_started_date", label: "Application Started", type: "date" },
      { key: "application_submitted_date", label: "Application Submitted", type: "date" },
      { key: "carrier_decision", label: "Carrier Decision", type: "select", options: CARRIER_DECISIONS },
      { key: "policy_number", label: "Policy Number", type: "text" },
      { key: "effective_date", label: "Effective Date", type: "date" },
      { key: "assigned_agent", label: "Assigned Agent", type: "select", optionsKey: "agents" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  requotes: {
    title: "Pending / Requote", collection: "requotes", idLabel: "Case",
    columns: [
      { key: "display_id", label: "ID", type: "mono" },
      { key: "client_name", label: "Client" },
      { key: "original_carrier", label: "Orig. Carrier" },
      { key: "original_premium", label: "Orig. Premium", type: "currency", align: "right" },
      { key: "current_status", label: "Requote Workflow Status", type: "badge" },
      { key: "reason", label: "Reason" },
      { key: "alternate_carrier", label: "Alt. Carrier" },
      { key: "instabrain_result", label: "InstaBrain" },
      { key: "revised_premium", label: "Revised", type: "currency", align: "right" },
      { key: "client_decision", label: "Decision", type: "badge" },
      { key: "next_followup_date", label: "Next F/U", type: "date" },
    ],
    fields: [
      { key: "client_name", label: "Client", type: "text", required: true },
      { key: "original_carrier", label: "Original Carrier", type: "select", optionsKey: "carriers" },
      { key: "original_product", label: "Original Product", type: "select", optionsKey: "products" },
      { key: "original_face_amount", label: "Original Face Amount", type: "number" },
      { key: "original_premium", label: "Original Premium", type: "number" },
      { key: "current_status", label: "Requote Workflow Status", type: "select", options: ["Delayed", "Declined", "Changed", "In Review"] },
      { key: "reason", label: "Reason for Delay/Decline", type: "textarea" },
      { key: "alternate_carrier", label: "Alternate Carrier to Try", type: "select", optionsKey: "carriers" },
      { key: "instabrain_result", label: "InstaBrain Result", type: "select", options: ["Pending run", "Match found", "No match"] },
      { key: "pivot_carrier_product", label: "Pivot Carrier / Product", type: "text" },
      { key: "revised_face_amount", label: "Revised Face Amount", type: "number" },
      { key: "revised_premium", label: "Revised Premium", type: "number" },
      { key: "client_decision", label: "Client Decision", type: "select", options: ["Pending", "Reviewing", "Accepted", "Declined"] },
      { key: "assigned_owner", label: "Assigned Owner", type: "select", optionsKey: "agents" },
      { key: "next_followup_date", label: "Next Follow-Up Date", type: "date" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  policies: {
    title: "Approved Policies", collection: "policies", idLabel: "Policy", calc: true, entity: "policies",
    columns: [
      { key: "display_id", label: "ID", type: "mono" },
      { key: "client_name", label: "Client" },
      { key: "carrier", label: "Carrier", emptyText: "Unknown / Not Recorded" },
      { key: "policy_number", label: "Policy #", type: "mono" },
      { key: "face_amount", label: "Face", type: "currency", align: "right" },
      { key: "monthly_premium", label: "Premium", type: "currency", align: "right" },
      { key: "payment_status", label: "Carrier-Verified Payment / Draft Status", type: "badge" },
      { key: "draft_date", label: "Draft", type: "date" },
      { key: "effective_date", label: "Effective", type: "date" },
      { key: "expected_commission", label: "Exp. Comm", type: "currency", align: "right" },
      { key: "commission_received", label: "Rec. Comm", type: "currency", align: "right" },
      { key: "policy_status", label: "Carrier-Verified Policy Status", type: "badge" },
      { key: "record_class", label: "Source", type: "badge" },
    ],
    fields: [
      { key: "client_name", label: "Client", type: "text", required: true },
      { key: "carrier", label: "Carrier", type: "select", optionsKey: "carriers" },
      { key: "product", label: "Product", type: "select", optionsKey: "products" },
      { key: "policy_number", label: "Policy Number", type: "text" },
      { key: "face_amount", label: "Face Amount", type: "number" },
      { key: "monthly_premium", label: "Monthly Premium", type: "number" },
      { key: "effective_date", label: "Effective Date", type: "date" },
      { key: "draft_date", label: "Draft Date", type: "date" },
      { key: "payment_status", label: "Carrier-Verified Payment / Draft Status", type: "select", options: ["PAID", "NSF", "Pending", "Unknown / Review"] },
      { key: "commission_percentage", label: "Commission %", type: "number" },
      { key: "expected_commission", label: "Expected Commission", type: "number" },
      { key: "commission_received", label: "Commission Received", type: "number" },
      { key: "commission_received_date", label: "Commission Received Date", type: "date" },
      { key: "check_30_day", label: "30-Day Check Done", type: "switch" },
      { key: "check_90_day", label: "90-Day Check Done", type: "switch" },
      { key: "annual_review_date", label: "Annual Review Date", type: "date" },
      { key: "policy_status", label: "Carrier-Verified Policy Status", type: "select", options: ["Active", "Pending Draft", "Payment Issue", "Lapse Risk", "Lapsed", "Cancelled"] },
      { key: "assigned_agent", label: "Assigned Agent", type: "select", optionsKey: "agents" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  followups: {
    title: "Follow-Up Queue", collection: "followups", idLabel: "Follow-Up", entity: "followups",
    columns: [
      { key: "display_id", label: "ID", type: "mono" },
      { key: "client_name", label: "Client" },
      { key: "resolved_phone", label: "Phone" },
      { key: "policy_number", label: "Policy #", type: "mono" },
      { key: "carrier", label: "Carrier" },
      { key: "verified_carrier_status", label: "Carrier-Verified Policy Status", type: "badge" },
      { key: "verified_payment_status", label: "Carrier-Verified Payment / Draft Status", type: "badge" },
      { key: "effective_followup_type", label: "Follow-Up Purpose", type: "badge" },
      { key: "triage_readiness", label: "Sophia Readiness", type: "badge" },
      { key: "ai_flags", label: "Flags", type: "ai_badges" },
      { key: "status_state", label: "Follow-Up Task Status", type: "badge" },
      { key: "due_date", label: "Due", type: "date" },
      { key: "assigned_to", label: "Assigned" },
      { key: "last_contact_date", label: "Last Contact Date", type: "date" },
      { key: "last_contact_result", label: "Last Result" },
      { key: "next_action", label: "Next Action" },
      { key: "referral_opportunity", label: "Referral" },
      // Section L: contact-link + Sophia audit trail -- safe operational fields
      // only (no PII beyond what the rest of this table already shows), so an
      // export can be traced back to exactly which contact link and which
      // Sophia session/attempt produced each outcome.
      { key: "link_status", label: "Contact Link Status", type: "badge" },
      { key: "automation_state", label: "Sophia Automation State", type: "badge" },
      { key: "ai_call_attempts", label: "Sophia Call Attempts" },
      { key: "ai_call_session_id", label: "Last Sophia Session ID", type: "mono" },
      { key: "sophia_hold", label: "Held From Sophia", type: "bool" },
      { key: "sophia_excluded", label: "Excluded From Sophia Runs", type: "bool" },
      { key: "sophia_human_review_required", label: "Sophia Human Review Required", type: "bool" },
    ],
    fields: [
      { key: "client_name", label: "Client", type: "text", required: true },
      { key: "resolved_phone", label: "Resolved Phone", type: "text", readOnly: true },
      { key: "resolved_phone_source", label: "Phone Source", type: "text", readOnly: true },
      { key: "policy_number", label: "Policy Number", type: "text" },
      { key: "carrier", label: "Carrier", type: "select", optionsKey: "carriers" },
      { key: "verified_carrier_status", label: "Carrier-Verified Policy Status", type: "text", readOnly: true },
      { key: "verified_payment_status", label: "Carrier-Verified Payment / Draft Status", type: "text", readOnly: true },
      { key: "effective_followup_type", label: "Effective Follow-Up Type", type: "text", readOnly: true },
      { key: "followup_type", label: "Source Follow-Up Type", type: "select", options: FOLLOWUP_TYPES, required: true },
      { key: "status_state", label: "Follow-Up Task Status", type: "select", options: FOLLOWUP_STATES },
      { key: "due_date", label: "Due Date", type: "date" },
      { key: "assigned_to", label: "Assigned To", type: "select", optionsKey: "agents" },
      { key: "last_contact_date", label: "Last Contact Date", type: "date" },
      { key: "last_contact_result", label: "Last Contact Result", type: "text" },
      { key: "next_action", label: "Next Action", type: "text" },
      { key: "policy_active", label: "Policy Active", type: "switch" },
      { key: "payment_issue", label: "Payment Issue", type: "switch" },
      { key: "referral_opportunity", label: "Referral / Cross-Sell", type: "text" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  commissions: {
    title: "Commissions", collection: "commissions", idLabel: "Entry", calc: true,
    columns: [
      { key: "display_id", label: "ID", type: "mono" },
      { key: "client_name", label: "Client" },
      { key: "carrier", label: "Carrier" },
      { key: "policy_number", label: "Policy #", type: "mono" },
      { key: "agent", label: "Agent" },
      { key: "commission_percentage", label: "%", align: "right" },
      { key: "expected_commission", label: "Expected", type: "currency", align: "right" },
      { key: "commission_received", label: "Received", type: "currency", align: "right" },
      { key: "lead_cost", label: "Lead Cost", type: "currency", align: "right" },
      { key: "net_commission", label: "Net", type: "currency", align: "right" },
      { key: "chargeback_status", label: "Chargeback", type: "badge" },
    ],
    fields: [
      { key: "client_name", label: "Client", type: "text", required: true },
      { key: "carrier", label: "Carrier", type: "select", optionsKey: "carriers" },
      { key: "policy_number", label: "Policy Number", type: "text" },
      { key: "agent", label: "Agent", type: "select", optionsKey: "agents" },
      { key: "monthly_premium", label: "Monthly Premium", type: "number" },
      { key: "commission_percentage", label: "Commission %", type: "number" },
      { key: "expected_commission", label: "Expected Commission", type: "number" },
      { key: "commission_received", label: "Commission Received", type: "number" },
      { key: "date_received", label: "Date Received", type: "date" },
      { key: "lead_cost", label: "Lead Cost", type: "number" },
      { key: "net_commission", label: "Net Commission", type: "number" },
      { key: "chargeback_amount", label: "Chargeback Amount", type: "number" },
      { key: "chargeback_status", label: "Chargeback Status", type: "select", options: ["None", "Pending", "Resolved"] },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
  scorecard: {
    title: "Carrier & Vendor Scorecard", collection: "scorecard", idLabel: "Vendor",
    columns: [
      { key: "name", label: "Carrier / Vendor" },
      { key: "type", label: "Type" },
      { key: "rating", label: "Rating", type: "rating" },
      { key: "product_type", label: "Product" },
      { key: "commission_percentage", label: "Comm %", align: "right" },
      { key: "applications_leads", label: "Apps/Leads", align: "right" },
      { key: "approvals", label: "Approvals", align: "right" },
      { key: "declines", label: "Declines", align: "right" },
      { key: "avg_decision_time_days", label: "Avg Days", align: "right" },
      { key: "chargebacks", label: "Chargebacks", align: "right" },
    ],
    fields: [
      { key: "name", label: "Carrier / Vendor Name", type: "text", required: true },
      { key: "type", label: "Type", type: "select", options: ["Carrier", "Lead Vendor", "Tech Vendor"] },
      { key: "rating", label: "Rating", type: "select", options: ["green", "orange", "red"], required: true },
      { key: "product_type", label: "Product Type", type: "select", optionsKey: "products" },
      { key: "commission_percentage", label: "Commission %", type: "number" },
      { key: "lead_cost", label: "Lead Cost", type: "number" },
      { key: "applications_leads", label: "Applications / Leads", type: "number" },
      { key: "approvals", label: "Approvals", type: "number" },
      { key: "declines", label: "Declines", type: "number" },
      { key: "avg_decision_time_days", label: "Avg Decision Time (days)", type: "number" },
      { key: "avg_commission_received", label: "Avg Commission Received", type: "number" },
      { key: "chargebacks", label: "Chargebacks", type: "number" },
      { key: "notes", label: "Notes", type: "textarea" },
    ],
  },
};
